import styled from "@emotion/styled";
import { fontAngkor } from "@product/scmp-sdk";

import { ContentCoverImage } from "~/components/content/content-cover-image";
import { Figure } from "~/components/content/content-cover-image/styles";
import {
  Headline as ContentHeadline,
  SponsorHeadline,
} from "~/components/content/content-headline/styles";
import { EntityLink } from "~/components/entity-link";
import { Button } from "~/components/posties/button";
import { OffsetContainer } from "~/components/posties/offset-container";

export const StyledButton = styled(Button)``;

export const StyledContentCoverImage = styled(ContentCoverImage)`
  border-radius: 20px;
`;

export const StyledOffsetContainer = styled(OffsetContainer)`
  margin-inline-start: 10px;

  ${Figure} {
    position: relative;
    inset-block-start: 8px;
    inset-inline-end: 8px;

    inline-size: 100%;
    block-size: 100%;

    border-radius: 20px;

    ${props => props.theme.breakpoints.up("tablet")} {
      inset-block-start: 9px;
      inset-inline-end: 9px;
    }
    ${props => props.theme.breakpoints.up("desktop")} {
      inset-block-start: 10px;
      inset-inline-end: 10px;
    }
  }
`;

export const Headline = styled.div`
  margin-block-end: 20px;
  ${ContentHeadline}, ${SponsorHeadline} {
    inline-size: 100%;

    font-weight: 400;
    font-size: 24px;
    font-family: ${fontAngkor};
    line-height: 28px;
    letter-spacing: -0.72px;
    text-align: center;
    ${props => props.theme.breakpoints.up("tablet")} {
      margin-block-start: 41px;

      font-size: 32px;
      line-height: 38px;
      letter-spacing: -0.96px;
    }
    ${props => props.theme.breakpoints.up("desktop")} {
      margin-block-start: 42px;
    }
  }
`;

export const StyledEntityLink = styled(EntityLink)`
  display: grid;
  grid:
    "image" min-content
    "content" min-content
    "read-more" min-content
    / 100%;
  justify-content: center;
  align-items: center;

  inline-size: 100%;
  margin-inline: auto;
  padding-inline: 24px;
  ${props => props.theme.breakpoints.up("tablet")} {
    inline-size: 640px;
    padding-inline: 0;
  }
  ${props => props.theme.breakpoints.up("desktop")} {
    inline-size: 712px;
    margin-inline: auto;
  }

  ${Headline} {
    grid-area: content;
  }

  ${StyledButton} {
    grid-area: read-more;
  }

  ${StyledOffsetContainer} {
    grid-area: image;
  }
`;

export const Content = styled.div`
  margin-block-start: 40px;

  text-align: center;
`;

export const Container = styled.div``;
